module.exports = __webpack_public_path__ + "img/sort／phone／Boy@2x.2b246566.png";